function scrollToTarget(targetId, offsetElem) {
  const targetElement = document.querySelector(targetId);
  if (targetElement) {
    const offset = offsetElem ? offsetElem.offsetHeight - 1 : 0;
    const offsetPosition = targetElement.offsetTop - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('body').classList.contains('page-distributors')) {

    const distrList = document.querySelector('.js-distr-list');
    if (distrList) {

      const distrHeading = document.querySelector('.js-distr-distributors-heading');
      const selectedCountryName = document.querySelector('.js-distr-selected-country');
      const headingText = document.querySelector('.js-distr-heading-text');

      function distrUpdateFilter(ID) {
        distrList.dataset.showCountry = ID;
      }

      function pressCountryBtn(btn, allBtns) {
        // unpress all
        for (let i = 0; i < allBtns.length; i++) {
          const countryBtn = allBtns[i];

          countryBtn.setAttribute('aria-pressed', 'false');
        }

        // press this one
        btn.setAttribute('aria-pressed', 'true');
      }

      // Get all country btns
      const countryBtns = document.querySelectorAll('.js-distr-country-btn');
      if (countryBtns) {
        // Add event listeners to country btns
        for (let i = 0; i < countryBtns.length; i++) {
          const countryBtn = countryBtns[i];

          countryBtn.addEventListener('click', function (e) {
            const countryID = e.currentTarget.dataset.countryId;

            // Update the filter
            distrUpdateFilter(countryID);

            // Toggle state of button(s)
            pressCountryBtn(countryBtn, countryBtns);

            // Update selected country text
            headingText.textContent = e.currentTarget.innerText === 'USA' ? 'Dealers' : 'Distributors';
            selectedCountryName.innerText = e.currentTarget.innerText;

            // Show the heading
            distrHeading.setAttribute('aria-hidden', 'false');

            // Trigger animation
            selectedCountryName.style.display = "none";
            setTimeout(function () {
              selectedCountryName.style.display = "";
            }, 10);

            // Add smooth scroll to distributors section
            scrollToTarget('#distributors', document.querySelector('[data-header]'));

          });
        }
      }

      // Get mobile select
      const countrySelect = document.querySelector('.js-distr-country-select');
      if (countrySelect) {
        countrySelect.addEventListener('change', function () {
          const countryText = countrySelect.options[countrySelect.selectedIndex].text;
          headingText.textContent = countryText === 'USA' ? 'Dealers' : 'Distributors';
          countryID = countrySelect.value;

          distrUpdateFilter(countryID);

          // Update selected country text
          selectedCountryName.innerText = countryText;

          // Show the heading
          distrHeading.setAttribute('aria-hidden', 'false');

          // Trigger animation
          selectedCountryName.style.display = "none";
          setTimeout(function () {
            selectedCountryName.style.display = "";
          }, 10);

          scrollToTarget('#distributors', document.querySelector('[data-header]'));

        });
      }
    }
  }
});